// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ddd9d421","194":"5b1ea294","453":"b03e3c98","535":"fa4398bd"}[chunkId] + ".chunk.js";
};